import React, { ChangeEvent, useContext, useRef, useState } from "react"
import { getItemFromId } from "@rubendenbrok/bloqmatter-cms"
import getCascadingColor from "../../functions/getCascadingColor"
import { getAbsolutePositionStyle } from "../../styles/util"
import H1 from "../atoms/H1"
import H2 from "../atoms/H2"
import { DEFAULT_BLOCKOPTIONS_DEFAULTS } from "@rubendenbrok/bloqmatter-cms"

import { DataContext } from "../Layout"
import BgVideo from "../molecules/BgVideo"
import ResponsiveBgImg from "../molecules/ResponsiveBgImg"
import H3 from "../atoms/H3"
import HoverLines from "../atoms/HoverLines"
import TextBasic from "../atoms/TextBasic"
import MenuButton from "../atoms/MenuButton"
import { handleScrollTo } from "../header/DesktopHeader"

/*
BESCHRIJVING:
Een Hero video die altijd de breedte van het scherm aanhoudt, met een eventuele tekst erover.

DATA:
{
  title: string
  subtitle: string
  text: html string
  textHorizontalPos: 'start' | 'center' | 'end'
  textVerticalPos: 'start' | 'center' | 'end'
  video: string (video ID)


}
*/

type props = any

export default function HeroMenuBlock_Display({ blockContent }: props) {
  const { cssVariables, thisPage, siteOverviewData, processedImageData } =
    useContext(DataContext)
  const [inputVal, setInputVal] = useState("")
  const [inputXVal, setInputXVal] = useState("")

  const [subscribeMsg, setSubscribeMsg] = useState("")
  const emailRef = useRef("")
  const fakeRef = useRef("")
  const formRef = useRef<HTMLFormElement | null>(null)

  function handleXChange(e: ChangeEvent<HTMLInputElement>) {
    fakeRef.current = e.target.value
    setInputXVal(e.target.value)
  }
  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    emailRef.current = e.target.value
    setInputVal(e.target.value)
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    const data: { [x: string]: any } = { ...formRef.current }
    setSubscribeMsg("Processing...")
    // console.log(data)
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        ...data,
        "form-name": "emailForm",
        email: emailRef.current,
      }).toString(),
    })
      .then(() => {
        console.log("Form successfully submitted")
        setSubscribeMsg("Thank you, you'll be the first to hear new music!")
      })
      .catch(e => {
        console.warn(e)
        setSubscribeMsg("Something went wrong, please try again later")
      })
  }

  return (
    <>
      <div className="w-full relative h-[75vh]">
        <div className="fadeInSlow text-center absolute w-full left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center pt-12 px-6 pb-4 rounded-xl">
          {blockContent.title && (
            <H1
              className={` text-center`}
              style={{
                color: thisPage
                  ? getCascadingColor(
                      cssVariables,
                      siteOverviewData,
                      thisPage,
                      blockContent
                    ).title
                  : "black",
                animationDelay: "0.5s",
              }}
            >
              {blockContent.title}
            </H1>
          )}

          <form
            ref={formRef}
            name={`emailForm`}
            data-netlify="true"
            netlify-honeypot="extra"
            action="/thanks-for-subcribing"
            className="flex flex-col md:items-center items-start mt-10 "
            onSubmit={handleSubmit}
          >
            <>
              {subscribeMsg ? (
                <H3>{subscribeMsg}</H3>
              ) : (
                <div className="flex flex-col items-center">
                  <H3 className="tracking-widest">Let's stay in touch</H3>
                  <div className="font-basic text-lg sm:text-xl md:text-2xl tracking-wide -mt-1">
                    Join my mailing list and be the first to hear my upcoming
                    album and future live shows
                  </div>
                </div>
              )}
              <div className="flex mt-4">
                <input
                  onChange={handleChange}
                  value={inputVal}
                  type="email"
                  name="email"
                  placeholder="Your email adress"
                  className="block outline-none h-12 text-white border border-white bg-gray-900 focus:bg-gray-700 transition-colors py-2 font-basic text-xl w-72 max-w-[60vw] md:mb-12 text-left pl-5 pr-5 md:pr-6 rounded-l-full rounded-r-none"
                ></input>

                <button className="block cursor-pointer hover:bg-white hover:text-black   border border-white transition-colors rounded-full font-basictext-xl h-12 px-4 p-0 -ml-6 w-32 tracking-widest bg-black ">
                  <div className="animate-pulse"> Join</div>
                </button>
              </div>
            </>
          </form>

          {/* <a
            href="https://manifoldmusic.netlify.app/"
            className="italic font-titleAccent md:text-xl cursor-pointer hover:underline mt-8 max-w-[70vw] px-4"
          >
            Click here to explore Manifold, an interactive online piano
            composition
          </a> */}
        </div>
      </div>
    </>
  )
}

export const HeroMenuBlock_Inputs = {
  key: "heroMenuBlock",
  name: "Hero Menu Block",
  tags: ["Video", "Media", "Hero", "Title"],
  description: "A hero video, with an optional title overlayed on top of it.",
  inputs: [
    {
      inputType: "expandableInputs",
      label: "Text",
      childInputs: [
        {
          inputType: "text",
          label: "Title",
          keyName: "title",
          defaultVal: "",
        },
      ],
    },
  ],
  defaults: {
    ...DEFAULT_BLOCKOPTIONS_DEFAULTS,
  },
}
